import { motion } from "framer-motion";
import AnimatedCounter from "@/components/AnimatedCounter";

const logos = [
  "Velocity", "Northstar", "Quantum Labs", "Atlas Capital", "Helix",
  "Aperture", "Forge & Foundry", "Lumen", "Parallax", "Sigma Health",
  "Skyward", "Beacon", "Nexus", "Verdant", "Drift Studio",
];

const stats = [
  { value: 150, suffix: "+", label: "Projects Delivered" },
  { value: 80, suffix: "+", label: "Happy Clients" },
  { value: 100, prefix: "₹", suffix: "Cr+", label: "Revenue Influenced" },
  { value: 96, suffix: "%", label: "Client Retention" },
];

export default function TrustMarquee() {
  return (
    <section data-testid="trust-section" className="section pt-16 sm:pt-20 pb-24 relative">
      <div className="container-x">
        <div className="text-center mb-12">
          <p className="overline">Trusted by ambitious teams worldwide</p>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative overflow-hidden mask-fade py-2">
        <div className="absolute inset-y-0 left-0 w-32 z-10 bg-gradient-to-r from-bg-0 to-transparent" />
        <div className="absolute inset-y-0 right-0 w-32 z-10 bg-gradient-to-l from-bg-0 to-transparent" />
        <div className="flex whitespace-nowrap marquee-track">
          {[...logos, ...logos].map((name, i) => (
            <div
              key={`${name}-${i}`}
              className="flex items-center gap-3 px-10 text-white/40 hover:text-white transition-colors"
            >
              <span className="w-2 h-2 rounded-sm bg-gradient-to-tr from-neon-cyan to-neon-magenta opacity-70" />
              <span className="font-semibold text-2xl tracking-tight">{name}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Stats grid */}
      <div className="container-x mt-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 rounded-3xl overflow-hidden glass">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="bg-bg-1/60 p-7 lg:p-9 relative group"
              data-testid={`stat-${i}`}
            >
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br from-neon-cyan/10 via-transparent to-neon-magenta/10 pointer-events-none" />
              <div className="font-mono text-4xl lg:text-5xl font-extrabold tracking-tight text-gradient-neon">
                <AnimatedCounter value={s.value} prefix={s.prefix || ""} suffix={s.suffix || ""} />
              </div>
              <div className="mt-2 text-sm text-white/55">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
